import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';

Vue.use(ElementUI);

import router from './router/index'



Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})